module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div id=\"<%= watchlistId %>\" class=\"watchlist-browse-item <%= content_type %>\">\n    <a href=\"<%= url %>\" aa-link=\"My List|<%= position %>|<%= watchlistId %>|<%= showId %>|<%= showTitle %>|<%= showGenre %>|<%= contentId %>|<%= movieTitle %>|<%= movieGenre %>\">\n    <div class=\"thumb-wrapper\">\n        <label  class=\"edit-container\">\n            <input type=\"checkbox\"\n                   name=\"editor\"\n                   value=\"<%= watchlistId %>\"\n                   aria-hidden=\"true\">\n            <span class=\"checkmark\" aria-hidden=\"true\"></span>\n            <div class=\"overlay\"></div>\n        </label>\n        <img class=\"thumb lazy\" src=\"<%= thumb || 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=' %>\" data-src=\"<%= thumb || '' %>\" alt=\"<%= title %>\" />\n        <div class=\"thumb-caption\"><%= thumbCaption %></div>\n    </div>\n    </a>\n</div>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/watchListBrowse/__watchListBrowseItem.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div id=\"")
    ; __append(escapeFn( watchlistId ))
    ; __append("\" class=\"watchlist-browse-item ")
    ; __append(escapeFn( content_type ))
    ; __append("\">\n    <a href=\"")
    ; __line = 2
    ; __append(escapeFn( url ))
    ; __append("\" aa-link=\"My List|")
    ; __append(escapeFn( position ))
    ; __append("|")
    ; __append(escapeFn( watchlistId ))
    ; __append("|")
    ; __append(escapeFn( showId ))
    ; __append("|")
    ; __append(escapeFn( showTitle ))
    ; __append("|")
    ; __append(escapeFn( showGenre ))
    ; __append("|")
    ; __append(escapeFn( contentId ))
    ; __append("|")
    ; __append(escapeFn( movieTitle ))
    ; __append("|")
    ; __append(escapeFn( movieGenre ))
    ; __append("\">\n    <div class=\"thumb-wrapper\">\n        <label  class=\"edit-container\">\n            <input type=\"checkbox\"\n                   name=\"editor\"\n                   value=\"")
    ; __line = 7
    ; __append(escapeFn( watchlistId ))
    ; __append("\"\n                   aria-hidden=\"true\">\n            <span class=\"checkmark\" aria-hidden=\"true\"></span>\n            <div class=\"overlay\"></div>\n        </label>\n        <img class=\"thumb lazy\" src=\"")
    ; __line = 12
    ; __append(escapeFn( thumb || 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=' ))
    ; __append("\" data-src=\"")
    ; __append(escapeFn( thumb || '' ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( title ))
    ; __append("\" />\n        <div class=\"thumb-caption\">")
    ; __line = 13
    ; __append(escapeFn( thumbCaption ))
    ; __append("</div>\n    </div>\n    </a>\n</div>\n")
    ; __line = 17
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/watchListBrowse/__watchListBrowseItem.tpl"

}